import { createReducer } from 'redux-create-reducer';
import {
  requestFormAction,
  receiveFormAction,
  updateDurationAction,
  updateDurationUnitAction,
  updatePlanningDateAction,
  updatePlanningTimeAction,
  updatePreplanningDateAction,
  updateSecondaryWorkerIdsAction,
  updateWorkerIdAction,
} from '../actions/form';

const initialState = {
  planningDate: undefined,
  planningTime: undefined,
  preplanningDate: undefined,
  visitDuration: undefined,
  visitDurationUnit: undefined,
  primaryWorkerId: undefined,
  secondaryWorkerIds: [],
  isFetching: false,
  errors: [],
};

const ERRORS = 'errors';

export const formReducer = createReducer(initialState, {
  [updatePlanningDateAction](state, action) {
    return {
      ...state,
      planningDate: action.payload,
    };
  },
  [updatePlanningTimeAction](state, action) {
    return {
      ...state,
      planningTime: action.payload,
    };
  },
  [updatePreplanningDateAction](state, action) {
    return {
      ...state,
      preplanningDate: action.payload,
    };
  },
  [updateDurationAction](state, action) {
    return {
      ...state,
      visitDuration: action.payload,
    };
  },
  [updateDurationUnitAction](state, action) {
    return {
      ...state,
      visitDurationUnit: action.payload,
    };
  },
  [updateWorkerIdAction](state, action) {
    return {
      ...state,
      primaryWorkerId: action.payload,
    };
  },
  [updateSecondaryWorkerIdsAction](state, action) {
    return {
      ...state,
      secondaryWorkerIds: action.payload,
    };
  },
  [requestFormAction](state) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [receiveFormAction](state, action) {
    return {
      ...action.payload,
      errors: [],
      isFetching: false,
    };
  },
  [ERRORS](state, action) {
    return {
      ...state,
      errors: action.payload,
    };
  },
});

export default formReducer;

export const getErrors = state => state.form.errors;
export const getPlanningDate = state => state.form.planningDate;
export const getPlanningTime = state => state.form.planningTime;
export const getPreplanningDate = state => state.form.preplanningDate;
export const getVisitDuration = state => state.form.visitDuration;
export const getVisitDurationUnit = state => state.form.visitDurationUnit;
export const getPrimaryWorkerId = state => state.form.primaryWorkerId;
export const getSecondaryWorkerIds = state => state.form.secondaryWorkerIds;
export const getForm = state => state.form;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step2/reducers/form.js